import React from "react";
import GraderWidget from "@/components/GraderWidget";

export default function GraderTab() {
  return (
    <div className="space-y-5">
      <div className="tt-card p-6">
        <h1 className="text-3xl font-black h-tight">Free Listing Grader</h1>
        <p className="text-sm text-zinc-500 mt-1">Paste any Etsy, Amazon, or Redbubble listing. No credit spent — this is your unfair advantage.</p>
      </div>
      <GraderWidget dark={false} />
    </div>
  );
}
